<script setup>
import { useToast } from '@/hooks/use-toast'

const { toasts } = useToast()
</script>

<template>
  <!-- z-[100]: por encima de Sheet/Dialog (z-50), que se montan después en el DOM y lo tapaban -->
  <div class="fixed bottom-4 right-4 z-[100] flex flex-col gap-2 pointer-events-none">
    <TransitionGroup name="toast">
      <div 
        v-for="t in toasts" 
        :key="t.id"
        :class="[
          'p-4 rounded-md shadow-lg border flex justify-between items-start min-w-[300px] pointer-events-auto transition-all duration-300',
          t.variant === 'destructive' ? 'bg-destructive text-destructive-foreground border-destructive' : 'bg-background border-border text-foreground'
        ]"
      >
        <div>
          <div v-if="t.title" class="font-semibold">{{ t.title }}</div>
          <div v-if="t.description" class="text-sm opacity-90">{{ t.description }}</div>
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}
.toast-enter-from {
  opacity: 0;
  transform: translateX(100%);
}
.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>
